// NotFound.js
import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100">
            <h1 className="text-4xl font-bold text-gray-800 mb-4">404 - Page Not Found</h1>
            <p className="text-lg text-gray-600 mb-8">Sorry, the page you are looking for does not exist.</p>
            <Link to="/" className="text-lg text-blue-600 hover:underline">Go to Home</Link>
            <img src="/images/logo-black.png" alt="404" className="mt-8 w-60 h-auto" />
        </div>
    );
};

export default NotFound;
